import { render, staticRenderFns } from "./ChartAge.vue?vue&type=template&id=183bfa45"
import script from "./ChartAge.vue?vue&type=script&lang=js"
export * from "./ChartAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports